export interface AuthNgrx {
  nickname: string | null;
  email: string | null;
  token: string | null;
  tokenRules: string | null;
  empresa: string | null;
  nomeEmpresa: string | null;
  linkLogo: string | null;
  roles: string[];
  logout?: boolean;
}

export const emptyAuth = (logout?: boolean): AuthNgrx => ({
  token: null,
  tokenRules: null,
  nickname: null,
  email: null,
  empresa: null,
  nomeEmpresa: null,
  linkLogo: null,
  roles: [],
  logout,
});

export const getRoles = (token: string): string[] => {
  const [_, payload] = token.split('.');
  const decodedJWT: {roles?: string[]} = payload ? JSON.parse(window.atob(payload)) : {};
  return decodedJWT?.roles || [];
};
